import { mockBuilder } from '../utils/builderHelper.es.js';
import { User } from './User.es.js';

/** @module Mocks */ /** typedoc */
function aUser() {
    return mockBuilder(new User('f27bc505-92e6-4253-a8ce-b01518e2c52b', 'FirstName', 'LastName', false));
}

export { aUser };
